export type TScreenType = 'mobile' | 'retina' | 'desktop';

const detectScreenType = (): TScreenType => {
  // Определяем мобильное разрешение
  if (matchMedia && matchMedia('(max-width: 767px)').matches) {
    return 'mobile';
  }
  // Определяем ретину
  if (
    (matchMedia &&
      matchMedia(
        'only screen and (min-resolution: 192dpi), only screen and (min-resolution: 2dppx), only screen and (min-resolution: 75.6dpcm)'
      ).matches) ||
    matchMedia(
      'only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (-o-min-device-pixel-ratio: 2/1), only screen and (min--moz-device-pixel-ratio: 2), only screen and (min-device-pixel-ratio: 2)'
    ).matches ||
    (window.devicePixelRatio && window.devicePixelRatio >= 2)
  ) {
    return 'retina';
  }

  return 'desktop';
};

export default detectScreenType;
